import $ from 'jquery';

export default class SizeChart {
	constructor(options) {
		const defaults = {
			el: '.js-size-chart',

			dom: {
				russian: '.js-size-russian',
				size: '.js-size',
				sizeSelect: '.js-size-select',
				selectItem: '.js-select-item',
				currentSize: '.js-select-current-text',
				selectInput: '.js-select-input'
			},
			classes: {
				russian: {
					active: 'size-chart__russian_state_active'
				},
				size: {
					active: 'size-chart__size_state_active'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$russian = this.$el.find(this.options.dom.russian);
		this.$size = this.$el.find(this.options.dom.size);
		this.$sizeSelect = this.$el.find(this.options.dom.sizeSelect);
		this.$selectItem = this.$el.find(this.options.dom.selectItem);
		this.$currentSize = this.$el.find(this.options.dom.currentSize);
		this.$selectInput = this.$el.find(this.options.dom.selectInput);
	}

	onClick(event) {
		const $target = $(event.target);
		const text = $target.text();
		const size = $target.data('value');
		const $targetSize = this.$size.filter('[data-size="' + size + '"]');

		this.$russian.removeClass(this.options.classes.russian.active);
		this.$size.removeClass(this.options.classes.size.active);
		this.$currentSize.text(text);
		this.$selectItem.attr('data-selected', null);
		this.$selectItem.each((i, elem) => {
			const $elem = $(elem);
			const value = $elem.data('value');
			if (value === size) {
				$elem.attr('data-selected', 'true');
			}
		});

		$target.addClass(this.options.classes.russian.active);
		$targetSize.addClass(this.options.classes.size.active);
	}

	selectSize(event) {
		const $target = $(event.currentTarget);
		const size = $target.data('value');
		const $targetSize = this.$size.filter('[data-size="' + size + '"]');

		this.$russian.removeClass(this.options.classes.russian.active);
		this.$size.removeClass(this.options.classes.size.active);

		$targetSize.addClass(this.options.classes.size.active);

		this.$russian.each((i, elem) => {
			const $elem = $(elem);
			const value = $elem.data('value');
			if (value === size) {
				$elem.addClass(this.options.classes.russian.active);
			}
		});
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$russian.on('click', this.onClick.bind(this));
			this.$sizeSelect.find(this.options.dom.selectItem).on('click', e => { this.selectSize(e); });
		}
		return this;
	}
}





/** WEBPACK FOOTER **
 ** ./app/blocks/size-chart/size-chart.js
 **/